// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import { BundleProductDescription } from './BundleProductDescription';
import { CommercialDesciption } from './CommercialDescription';

export function BundleDescription(): React.MixedElement {
  return (
    <Base flex flexCol>
      <CommercialDesciption />
      <BundleProductDescription />
    </Base>
  );
}
